export default __webpack_public_path__ + "static/team-meet-c502434723865797af6b5074afc4509f.jpg";